import React from "react";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
    const isLoggedIn = !!sessionStorage.getItem("access_token");
    return isLoggedIn ? <Navigate to="/product-dashboard" replace /> : children;
};

export default PublicRoute;
